<script setup lang="ts">
    import { useTheme } from 'vuetify';
    import { useAppStore } from '#imports';

    /* Store variables */
    const { isDarkMode, langs, userLang } = storeToRefs(useAppStore());

    /* Private variables */
    const _theme = useTheme();

    watch(isDarkMode, () => { setTheme(); });

    function setTheme(): void {
        _theme.global.name.value = isDarkMode.value ? 'theme_dark' : 'theme_light';
    }

    function init(): void {
        setTheme();
    }

    init();
</script>

<template>
    <v-row no-gutters
        class="ga-3">
        <v-col>
            <v-select
                v-model="userLang"
                :items="langs"
                item-title="name"
                item-value="id"
                style="width: fit-content !important; float: right !important;"
                color="primary"
                prepend-icon="mdi-translate"
                hide-details />
        </v-col>
        <v-btn
            icon
            variant="outlined"
            class="mr-3 my-auto rounded-circle"
            color="secondary"
            size="xsmall"
            @click.stop="isDarkMode = !isDarkMode">
            <v-icon
                icon="mdi-theme-light-dark"
                class="transition ma-1"
                size="small"
                :class="isDarkMode ? '' : 'flip'" />
        </v-btn>
    </v-row>
</template>

<style scoped>
    .transition {
        transition: 250ms;
    }
    
    .flip {
        transform: rotate(180deg);
    }
</style>